import FarmSelectPanelField from '../FarmSelectPanelField';

import { Wrapper } from '@american-autonomy/ag-ui';

import EntitySelectPillButton from 'components/EntitySelectPillButton';
import WithField from 'components/WithField';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FieldValues, Props } from './types';

import styles from './styles.module.scss';

const SelectFarmField = <T extends FieldValues>(props: Props<T>) => {
    const {
        className = '',
        clientId,
        control,
        isOpen,
        isRequired,
        label,
        name,
        onPanelClose,
        onPanelOpen,
        placeholder,
        ref,
        testId = TEST_ID
    } = props;

    const { FARM } = useTranslation();

    const { containerRef, handleClose, handleToggle, isPanelOpen, onChange, value } = useData<T>({
        clientId,
        control,
        isOpen,
        isRequired,
        name,
        onPanelClose,
        onPanelOpen,
        ref
    });

    const fieldLabel = label ?? FARM;

    return (
        <Wrapper
            className={`${styles.wrapper} ${isPanelOpen ? styles.panelOpen : ''} ${className}`}
            ref={containerRef}
            testId={testId}>
            <WithField className={styles.withField} label={fieldLabel}>
                <EntitySelectPillButton
                    hasValue={!!value}
                    onClick={handleToggle}
                    onRemove={() => onChange(null)}
                    text={value?.label ?? placeholder ?? FARM}
                />
            </WithField>

            {isPanelOpen && (
                <FarmSelectPanelField
                    clientId={clientId}
                    onChange={onChange}
                    onClose={handleClose}
                    value={value}
                />
            )}
        </Wrapper>
    );
};

export default SelectFarmField;
